import React from 'react'
import "./footer.css"
import {AiFillTwitterSquare} from "react-icons/ai"
import {AiFillLinkedin} from "react-icons/ai"
import {AiFillGithub} from "react-icons/ai"

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer_logo'>Boreinc</a>
      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        {/* <li><a href="#services">Services</a></li> */}
        <li><a href="#portfolio">Portfolio</a></li>
        {/* <li><a href="#testimonials">Testimonials</a></li> */}
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer_socials">
        <a href="https://twitter.com/Boreinc23" target="_blank"><AiFillTwitterSquare/></a>
        <a href="https://www.linkedin.com/in/caden-smith-7806a3223/" target="_blank"><AiFillLinkedin/></a>
        <a href="https://github.com/Cadensmith1123" target="_blank"><AiFillGithub/></a>
      </div>

      <div className="footer_copyright">
        <small>&copy; Boreinc Freelancing Services</small>
      </div>
    </footer>
  )
}

export default Footer